import moment from 'moment';

class expertAnalyzeStatus {
  constructor(props) {
    const el = document.createElement('div');
    const rowData = props.grid.getRow(props.rowKey);
    this.el = el;
    this.render(props);
  }

  getElement() {
    return this.el;
  }

  getValue() {
    return this.el.value;
  }

  render(props) {
    const rowData = props.grid.getRow(props.rowKey);
    const rowStatusText = rowData.statusNm;
    if (props.value === 'EXPRT01') {
      this.el = document.createElement('button');
      this.el.classList.add('btn', 'xsm');
      this.el.innerHTML = '신청';
    } else {
      this.el = document.createElement('div');
      this.el.innerHTML = rowStatusText;
    }
  }
}

class expertAnalyzeDateFormat {
  tructor(props) {
    const el = document.createElement('span');
    this.el = el;
    this.render(props);
  }

  getElement() {
    return this.el;
  }

  getValue() {
    return this.el.value;
  }

  render(props) {
    if (props.value != null && props.value != '') {
      const today = moment(props.value);
      this.el.innerHTML = today.format('YYYY-MM-DD');
    } else {
      this.el.innerHTML = '';
    }
  }
}

class ExpertConsultGridButton {
  constructor(props) {
    const el = document.createElement('span');
    const rowData = props.grid.getRow(props.rowKey);
    if (
      rowData.cnsltSttsCd === 'EXPRT05' //EXPRT05 전문가분석완료
    ) {
      el.innerHTML = '신청대기';
    } else {
      el.innerHTML = props.value;
    }

    this.el = el;
  }
  getElement() {
    return this.el;
  }
  render(props) {}
}

class ExpertConsultGridButton2 {
  constructor(props) {
    const rowData = props.grid.getRow(props.rowKey);
    var el = document.createElement('button');
    if (
      rowData.cnsltSttsCd === 'EXPRT05' //EXPRT05 전문가분석완료
    ) {
      el.textContent = '신청';
      el.classList.add('btn', 'xsm');
    } else {
      el = document.createElement('span');
      el.innerHTML = props.value;
    }

    this.el = el;
  }
  getElement() {
    return this.el;
  }
  render(props) {}
}

class expertAuditStatus {
  constructor(props) {
    const el = document.createElement('div');
    const rowData = props.grid.getRow(props.rowKey);
    this.el = el;
    this.render(props);
  }

  getElement() {
    return this.el;
  }

  getValue() {
    return this.el.value;
  }

  render(props) {
    const rowData = props.grid.getRow(props.rowKey);
    const rowStatusText = rowData.statusNm;
    this.el = document.createElement('div');
    this.el.innerHTML = rowStatusText;
  }
}

class checkBox {
  constructor(props) {
    const rowData = props.grid.getRow(props.rowKey);

    const inputWrap = document.createElement('div');
    this.inputWrap = inputWrap;
    this.inputWrap.classList.add('tui-grid-cell-content');
    this.inputWrap.classList.add('form-check');

    const el = document.createElement('input');

    this.el = el;
    this.el.type = 'checkbox';
    this.el.checked = props.value === 'Y';
    this.el.name = 'selected';

    // wrapper에 checkbox 추가
    this.inputWrap.appendChild(this.el);

    this.el.addEventListener('change', e => {
      if (props.onChange) {
        props.onChange(e.target.checked ? 'Y' : 'N');
      }
    });
  }

  getElement() {
    return this.inputWrap;
  }

  getValue() {
    return this.inputWrap.checked ? 'Y' : 'N';
  }
}

export default function getRendererClass(id) {
  switch (id) {
    case 'expertAnalyzeStatus':
      return expertAnalyzeStatus;
    case 'expertAnalyzeDateFormat':
      return expertAnalyzeDateFormat;
    case 'ExpertConsultGridButton':
      return ExpertConsultGridButton;
    case 'ExpertConsultGridButton2':
      return ExpertConsultGridButton2;
    case 'ExpertAuditStatus':
      return expertAuditStatus;
    case 'checkBox':
      return checkBox;
  }
}
